export const metaTags = {
  metaTitle: "Your Shopping Cart",
  metaDescription: "Your Shopping Cart",
  image:
    "https://cdn.shopify.com/s/files/1/0071/2081/4195/products/main_050e6db5-dc15-47b8-9bad-14d600333819_600x600_crop_center.jpg?v=1565936416",
};
